





























import Vue from 'vue'
export default Vue.extend({
    name: 'MenuSelector',
    props: {
        /* 
         The items displayed in the v-list
         @param Bool active
         @param String value 
        */
        items: {
            type: Array,
            required: true
        },
        // The text on the button
        title: {
            type: String,
            required: false,
            default: 'Button'
        },
        // Icon mode
        icon: {
            type: String,
            required: false,
            default: null
        }
    }
})
